import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { GlobalContext } from "../../Context/GlobalState";
import { ReviewBillTableAdmin } from "./Salarytable";
import { useQuery } from "../../utils/useQuery";
import { Button, Col, Row } from "react-bootstrap";
import { Doughnut } from "react-chartjs-2";
import { SalaryExpenseAdminModal } from "../Modal";
const ExpenseDashboardAdmin = () => {
  const query = useQuery();
  const id = query.get("id");
  const CompanyName = sessionStorage.getItem("CompanyName");
  const [activeLink, setActiveLink] = useState("expenses");
  const { accessData } = useContext(GlobalContext);
  // useEffect(() => {
  //   // console.log("Access Data:", accessData);
  // }, [accessData]);

  const renderContent = () => {
    switch (activeLink) {
      case "expenses":
        return <ExpensesAdmin />;
      case "bills":
        return <ReviewBillTableAdmin />;
      default:
        return null;
    }
  };

  return (
    <>
      <div className="m-5">
        <nav className=" navbar-expand-lg navbar-light bg-light">
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className="collapse navbar-collapse mx-md-4 mx-sm-2"
            id="navbarNav"
          >
            <ul className="navbar-nav">
              <li className="nav-item me-4">
                <Link
                  className={`nav-link green-link ${
                    activeLink === "expenses" && "active"
                  }`}
                  onClick={() => setActiveLink("expenses")}
                >
                  Expenses
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={`nav-link green-link ${
                    activeLink === "bills" && "active"
                  }`}
                  onClick={() => setActiveLink("bills")}
                >
                  Bills
                </Link>
              </li>
            </ul>
          </div>
        </nav>
        {renderContent()}
      </div>
    </>
  );
};
const ExpensesAdmin = () => {
  const [isExpenseModalOpen, setIsExpenseModalOpen] = useState(false);

  const openExpenseModal = () => {
    setIsExpenseModalOpen(true);
  };

  const closeExpenseModal = () => {
    setIsExpenseModalOpen(false);
  };

  const { accessData } = useContext(GlobalContext);

  // useEffect(() => {
  //   console.log("Access Data:", accessData);
  // }, [accessData]);

  const doughnutData = {
    labels: ["Category 1", "Category 2", "Category 3"],
    datasets: [
      {
        data: [30, 40, 20],
        backgroundColor: ["#40E0D0", "#5D8AA8", "#004F98"],
      },
    ],
  };

  const doughnutOptions = {
    responsive: true,
    maintainAspectRatio: true,
    elements: {
      arc: {
        borderWidth: 0.8,
      },
    },
    cutoutPercentage: 70,
  };

  const navigate = useNavigate();
  const Viewexpanse = () => navigate("/admin/ViewSalaryExpenseAdmin");

  return (
    <>
      {/* <div>
        <Calendar />
      </div> */}
      <div className="row mt-md-3 mt-sm-3 p-0 mt-sm-3">
        <div className="col-6 mx-md-5 mx-sm-3 mb-sm-3">
          <h1>
            <b> All your expenses in one place</b>
          </h1>
          <p style={{ fontSize: "1rem" }}>
            Save hours of work by tracking expenses
          </p>
          <div className="row m-0 p-0">
            <h2 className="col-md-1 col-sm-2" style={{ color: "#2ca01c" }}>
              <b>@</b>
            </h2>
            <p
              className="d-flex d-flex align-items-center col m-0 p-0"
              style={{ fontSize: "1rem", color: "#000" }}
            >
              &nbsp; Add & Manage your expenses here
            </p>
          </div>
          <div className="row p-0 m-0">
            <h2 className="col-md-1 col-sm-2" style={{ color: "#2ca01c" }}>
              <b>#</b>
            </h2>
            <p
              className="d-flex d-flex align-items-center col m-0 p-0"
              style={{ fontSize: "1rem", color: "#000" }}
            >
              &nbsp; Organize your expenses into categories
            </p>
          </div>
          <div className="row p-0 m-0 ">
            <h2 className="col-md-1 col-sm-2" style={{ color: "#2ca01c" }}>
              <b>@</b>
            </h2>
            <p
              className="d-flex align-items-center col p-0 m-0"
              style={{ fontSize: "1rem", color: "#000" }}
            >
              &nbsp; See where you're spending your money
            </p>
          </div>
          <div className="mt-md-3 mt-sm-2">
            <Row className="p-0">
              <Col className="d-flex align-items-center gap-2">
                {accessData &&
                  accessData.map(
                    (module) =>
                      module.data &&
                      module.data.map((role) =>
                        role.role_name === "Add Expense" ? (
                          role.access === "Y" ? (
                            <span key={role.pk_role_id}>
                              <button
                                type="button"
                                className="btn btn-sm d-flex align-items-center justify-content-center"
                                style={{
                                  background: "#2ca01c",
                                  height: "2.5em",
                                  border: "None",
                                  color: "#fff",
                                }}
                                onClick={openExpenseModal}
                              >
                                Add expense manually
                              </button>
                            </span>
                          ) : (
                            <span key={role.pk_role_id}>
                              <button
                                className="btn btn-sm btn-primary d-flex justify-content-center"
                                style={{
                                  color: "#fff",
                                  height: "2rem",
                                  border: "none",
                                  borderRadius: ".4rem",
                                  display: "flex",
                                  alignItems: "center",
                                  fontSize: ".8rem",
                                  backgroundColor: "gray",
                                  cursor: "not-allowed",
                                }}
                                disabled
                              >
                                Add expense manually
                              </button>
                            </span>
                          )
                        ) : null,
                      ),
                  )}
                <div style={{ marginLeft: ".5rem", marginRight: ".5rem" }}>
                  {accessData &&
                    accessData.map(
                      (module) =>
                        module.data &&
                        module.data.map((role) =>
                          role.role_name === "View Expense" ? (
                            role.access === "Y" ? (
                              <span key={role.pk_role_id}>
                                <button
                                  type="button"
                                  className="btn btn-sm d-flex align-items-center justify-content-center"
                                  style={{
                                    background: "#2ca01c",
                                    height: "2.5em",
                                    border: "None",
                                    color: "#fff",
                                  }}
                                  onClick={Viewexpanse}
                                >
                                  View expense
                                </button>
                              </span>
                            ) : (
                              <span key={role.pk_role_id}>
                                <button
                                  className="btn btn-sm btn-primary d-flex justify-content-center"
                                  style={{
                                    color: "#fff",
                                    height: "2rem",
                                    border: "none",
                                    borderRadius: ".4rem",
                                    display: "flex",
                                    alignItems: "center",
                                    fontSize: ".8rem",
                                    backgroundColor: "gray",
                                    cursor: "not-allowed",
                                  }}
                                  disabled
                                >
                                  View expense
                                </button>
                              </span>
                            )
                          ) : null,
                        ),
                    )}
                </div>
              </Col>
            </Row>
          </div>
          <div className="mt-md-3 mt-sm-2">
            <Row className="p-0">
              <Col className="d-flex align-items-center gap-2">
                <Link to="/admin/View-Vendor-Bill">
                  <Button
                    size="sm"
                    variant="success"
                    style={{ height: "2.2rem" }}
                  >
                    Vendor Expense
                  </Button>
                </Link>
              </Col>
            </Row>
          </div>
        </div>

        <div className="col mr-md-4 mr-sm-3 d-flex justify-content-center">
          <div
            style={{
              background: "#fff",
              boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
            }}
          >
            <h6 style={{ color: "grey" }} className="m-3">
              SPENDING LAST MONTH
            </h6>
            <h5 style={{ color: "grey" }} className="m-3">
              ₹1222
            </h5>
            {/* <Doughnut data={doughnutData} options={doughnutOptions} /> */}
            <div style={{ width: "300px", height: "300px" }}>
              <Doughnut data={doughnutData} options={doughnutOptions} />
            </div>

            <SalaryExpenseAdminModal
              isOpen={isExpenseModalOpen}
              closeModal={closeExpenseModal}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default ExpenseDashboardAdmin;
